module.exports = __webpack_public_path__ + "ba6c9b74a165003aa23008c265b87907.jpg";